<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M6.46213 7.68148C7.0806 8.90556 7.90113 10.0537 8.92373 11.0763C9.94633 12.0989 11.0945 12.9194 12.3186 13.5379L13.5813 12.2751C13.8512 12.0053 14.2698 11.9532 14.5975 12.1487L16.7894 13.4563C17.2557 13.7345 17.3357 14.3772 16.9517 14.7612L14.6843 17.0286C14.2636 17.4493 13.6484 17.6201 13.0835 17.4335C11.9775 17.068 10.9024 16.5829 9.87838 15.9781C8.70158 15.2831 7.59227 14.43 6.58116 13.4189C5.57005 12.4078 4.71698 11.2985 4.02195 10.1217C3.41716 9.09765 2.93204 8.02253 2.56659 6.91652C2.37993 6.35162 2.55077 5.73642 2.97146 5.31573L5.23884 3.04835C5.62281 2.66438 6.26556 2.74433 6.54376 3.21067L7.85132 5.4025C8.04683 5.73022 7.99475 6.14886 7.72492 6.4187L6.46213 7.68148Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'PhoneIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>